var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('small',_vm._l((_vm.eventTypes),function(eventType){return _c('span',{key:eventType.id,staticClass:"mr-3"},[_c('i',{staticClass:"fas fa-circle",style:({ color: eventType.color })}),_vm._v(" "+_vm._s(eventType.title)+" ")])}),0)]),_c('FullCalendar',{attrs:{"options":_vm.configOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }